import React, { useEffect } from 'react';

import AerospaceInsightsCards from './AerospaceInsightsCards';
import Aerosapacedatabanner from './Aerosapacedatabanner';
import Aerosapcehoverddata from './Aerosapcehoverddata';
import Aerosapcedata from './Aerosapcedata';
import AeroVerticalTabss from './AeroVerticalTabss';
import AerospaceButtons from './AerospaceButtons';
import Itrequestform from './Itrequestform';
import Footer from './Footer';
import Crigotpage from './Crigotpage';
import AerospaceSecondVerticaltab from './AerospaceSecondVerticaltab';
import AerospacecargotCards from './AerospacecargotCards';
import AeroSpaceThirdtab from './AeroSpaceThirdtab';

const Aerospace = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  return (
    <div style={{ background: '#fff', fontFamily: '"Helvetica Neue", sans-serif' }}>
      <Aerosapacedatabanner />
      <AerospaceButtons />
      <Aerosapcedata />
      <AeroVerticalTabss />
      <AerospaceSecondVerticaltab />
      <AeroSpaceThirdtab />
      <Crigotpage />
      <div className='mobile-crigot'>
        <AerospacecargotCards />
      </div>
      {/* <AerospaceInsightsCards /> */}
      <br />
      <Itrequestform />
      <div style={{ marginTop: '-60px' }}>
        <Footer />
      </div>

      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  );
};

export default Aerospace;
